import baseLayer from "../images/logo/base.svg";
import textLayer from "../images/logo/text.svg";
import topLayer from "../images/logo/top.svg";
import "../styles/logo.css";

interface LogoProps {
  /** When true, the text ring spins continuously around its center. */
  rotate?: boolean;
  /** Extra class on the root, e.g. for sizing. */
  className?: string;
}

function Logo({ rotate = false, className }: LogoProps) {
  return (
    <div
      className={`emblem${rotate ? " emblem--spin" : ""}${className ? ` ${className}` : ""}`}
      role="img"
      aria-label="Detroit Anti-War Committee logo"
    >
      <img className="emblem__layer emblem__base" src={baseLayer} alt="" aria-hidden="true" />
      <img className="emblem__layer emblem__text" src={textLayer} alt="" aria-hidden="true" />
      <img className="emblem__layer emblem__top" src={topLayer} alt="" aria-hidden="true" />
    </div>
  );
}

export default Logo;
